@app.service 'staticRenderService', ($window) ->

  @get = ->
    /PhantomJS/.test($window.navigator.userAgent)

  this
